// Enhanced Cart Icon Updater - Compatible with existing pubsub.js
class CartIconUpdater extends HTMLElement {
  constructor() {
    super();
    this.cartIcon = null;
    this.updateTimeout = null;
    this.unsubscribe = null;
  }

  connectedCallback() {
    console.log('[CartIconUpdater] Initializing...');
    
    this.cartIcon = document.getElementById('cart-icon-bubble');
    
    if (!this.cartIcon) {
      console.warn('[CartIconUpdater] Cart icon not found on initialization');
    }
    
    // Subscribe to cart update events using the existing pubsub system
    if (typeof subscribe !== 'undefined') {
      console.log('[CartIconUpdater] Subscribing to cart updates');
      
      // Get the event name from PUB_SUB_EVENTS or use default
      const eventName = window.PUB_SUB_EVENTS?.cartUpdate || 'cart-update';
      console.log('[CartIconUpdater] Subscribing to event:', eventName);
      
      this.unsubscribe = subscribe(eventName, (event) => {
        console.log('[CartIconUpdater] Cart update received:', event);
        this.updateCartIcon(event.cartData);
      });
      
      console.log('[CartIconUpdater] Subscription successful');
    } else {
      console.error('[CartIconUpdater] subscribe function not available!');
    }
    
    // Also listen for custom events as backup
    document.addEventListener('cart:updated', (event) => {
      console.log('[CartIconUpdater] Cart update via custom event');
      this.updateCartIcon(event.detail.cartData);
    });
    
    console.log('[CartIconUpdater] Initialized successfully');
  }

  disconnectedCallback() {
    // Cleanup subscription when element is removed
    if (this.unsubscribe) {
      this.unsubscribe();
    }
  }

  updateCartIcon(cartData) {
    console.log('[CartIconUpdater] updateCartIcon called with:', cartData);
    
    // Debounce updates to avoid multiple fetches
    if (this.updateTimeout) {
      clearTimeout(this.updateTimeout);
    }
    
    this.updateTimeout = setTimeout(() => {
      this.performUpdate(cartData);
    }, 100);
  }

  performUpdate(cartData) {
    const cartIcon = document.getElementById('cart-icon-bubble');
    if (!cartIcon) {
      console.warn('[CartIconUpdater] Cart icon not found in DOM');
      return;
    }

    console.log('[CartIconUpdater] Fetching updated header section...');

    // Fetch the header section to get updated cart icon
    const sectionUrl = `${window.Shopify?.routes?.root || '/'}?section_id=header`;
    console.log('[CartIconUpdater] Fetching from:', sectionUrl);

    fetch(sectionUrl)
      .then((response) => {
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        console.log('[CartIconUpdater] Response received');
        return response.text();
      })
      .then((responseText) => {
        console.log('[CartIconUpdater] Parsing HTML...');
        
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const newCartIcon = html.querySelector('#cart-icon-bubble');
        
        if (newCartIcon) {
          console.log('[CartIconUpdater] New cart icon found, replacing...');
          
          // Get the current cart icon again (in case it changed)
          const currentCartIcon = document.getElementById('cart-icon-bubble');
          
          if (currentCartIcon) {
            // Replace the entire cart icon element
            currentCartIcon.replaceWith(newCartIcon);
            console.log('[CartIconUpdater] ✅ Cart icon replaced successfully');
            
            // Verify the update
            setTimeout(() => {
              const updatedIcon = document.getElementById('cart-icon-bubble');
              if (updatedIcon) {
                const cbmDiv = updatedIcon.querySelector('.cart-cbm-mtf');
                const countDiv = updatedIcon.querySelector('.cart-count-mtf');
                console.log('[CartIconUpdater] Verification:');
                console.log('  - CBM div found:', !!cbmDiv);
                console.log('  - Count div found:', !!countDiv);
                if (cbmDiv) {
                  console.log('  - CBM content:', cbmDiv.textContent.trim());
                }
                if (countDiv) {
                  console.log('  - Count content:', countDiv.textContent.trim());
                }
              }
            }, 50);
          } else {
            console.warn('[CartIconUpdater] Current cart icon not found during replacement');
          }
        } else {
          console.warn('[CartIconUpdater] New cart icon not found in fetched HTML');
          console.log('[CartIconUpdater] Response preview:', responseText.substring(0, 500));
        }
      })
      .catch((e) => {
        console.error('[CartIconUpdater] ❌ Error updating cart icon:', e);
      });
  }
}

customElements.define('cart-icon-updater', CartIconUpdater);

// Initialize the updater when DOM is ready
const initCartIconUpdater = () => {
  console.log('[CartIconUpdater] Checking for existing updater element...');
  
  if (!document.querySelector('cart-icon-updater')) {
    console.log('[CartIconUpdater] Creating new updater element');
    const updater = document.createElement('cart-icon-updater');
    document.body.appendChild(updater);
    console.log('[CartIconUpdater] Updater element created and appended to body');
  } else {
    console.log('[CartIconUpdater] Updater element already exists');
  }
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initCartIconUpdater);
} else {
  initCartIconUpdater();
}